import { useCallback } from 'react'
import { closeModal, useAppDispatch } from '@open-tender/cloud'
import { CreditCardForm, ModalContent, ModalView } from 'components'

export interface CreditCardModalProps extends Record<string, unknown> {
  callback: () => void
  revenue_center_id: number
  RCrequire_cardholder_name: boolean
  setCvvCard?: (cvv?: string) => void
}

const CreditCard = ({
  windowRef,
  callback,
  revenue_center_id,
  RCrequire_cardholder_name,
  setCvvCard,
}: CreditCardModalProps & { windowRef: React.RefObject<HTMLDivElement> }) => {
  const dispatch = useAppDispatch()

  const addCallback = useCallback((cvv?: string) => {
    if (callback) callback()
    if(setCvvCard) setCvvCard(cvv)
    dispatch(closeModal())
  }, [dispatch, callback, setCvvCard])

  return (
    <ModalView>
      <ModalContent title="Add a new credit card">
        <CreditCardForm
          windowRef={windowRef}
          callback={addCallback}
          revenue_center_id={revenue_center_id}
          RCrequire_cardholder_name={RCrequire_cardholder_name}
        />
      </ModalContent>
    </ModalView>
  )
}

export default CreditCard
